import React from 'react';
import { Field } from 'redux-form';
import { Grid } from 'semantic-ui-react';

import { InputMode } from 'Common/FormEnum';
import {
  InputField,
  DatePickerField,
  CheckboxField,
} from 'Common/SemanticWrapper';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';

export const CalenderInfoFields = ({ formValues, change }) => {
  return (
    <Grid>
      <Grid.Row columns={4}>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Description'}
            maxLength={30}
            name={Fields.Description}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            disabled
            label={'Meal Benefit Expiration'}
            name={Fields.MealExpirationDT}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={4}>
        <Grid.Column>
          <Field
            className={'school-calendar--date-picker'}
            component={DatePickerField}
            dateFormat="MM/DD/YYYY"
            label={'First Day of School'}
            name={Fields.FirstDayDT}
            type={'text'}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            className={'school-calendar--date-picker'}
            component={DatePickerField}
            dateFormat={'MM/DD/YYYY'}
            label={'Last Day of School'}
            name={Fields.LastDayDT}
            type={'text'}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            disabled
            label={'Fiscal Year'}
            mode={InputMode.Integer}
            name={Fields.FiscalYear}
            type={'text'}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={4}>
        <Grid.Column>
          <Field
            className={'school-calendar--labeled-input'}
            component={InputField}
            fieldLabel={'Calendar'}
            labelPosition={'right'}
            label={'Grace Period Days'}
            maxLength={2}
            mode={InputMode.Integer}
            name={Fields.GracePeriodCalendarDays}
            type={'text'}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            className={'school-calendar--labeled-input'}
            component={InputField}
            fieldLabel={'Operational'}
            labelPosition={'right'}
            label={'CEP Transfer Days'}
            maxLength={2}
            mode={InputMode.Integer}
            name={Fields.CepTransferOperationalDays}
            type={'text'}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            className={'school-calendar--labeled-input'}
            component={InputField}
            disabled={
              formValues[Fields.MbeComplete] || !formValues[Fields.MbeEnabled]
            }
            fieldLabel={'Operational'}
            labelPosition={'right'}
            label={'MBE Days'}
            maxLength={2}
            mode={InputMode.Integer}
            name={Fields.MbeOperationalDays}
            type={'text'}
          />
        </Grid.Column>
        <Grid.Column verticalAlign={'middle'} width={3}>
          <Field
            component={CheckboxField}
            disabled={formValues[Fields.MbeComplete]}
            className={'school-calendar--mbe-checkbox'}
            label={'MBE Enabled'}
            name={Fields.MbeEnabled}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/CalendarInfoFields.js